<template>
  <div>
    <div :class="['scroll-wrap',info.config.list_bg === 'm01' ? 'white' : '']" v-if="data_list.length">
      <ul>
        <li class="welfare_block" v-for="(type_data, idx1) in data_list" :key="'type_' + idx1"  @click="click_img(type_data)">
          <div class="info">
            <div class="img-wrap">
              <img :src="type_data.head_img" alt="" />
            </div>
            <div class="left">
              <p class="title">{{ type_data.award_name }}</p>
              <span class="level">{{ type_data.sub_title }}</span>
            </div>
          </div>
          <BenefitButton :info="info" :type_data="type_data"/>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {jumpToMoreBenefit } from './benefitApi';
import BenefitButton from './BenefitButton.vue'
// 产品文档 https://wiki.imgo.tv/pages/viewpage.action?pageId=48204157


export default {
  name: 'NzmListAward',
  components: {
    BenefitButton
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {
    };
  },
  created() {},
  methods: {
    click_img: function(item) {
      if (item.award_type === 61 || item.award_type === 62) {
        // 蜂助手 Mcity不跳详情页
        return;
      }
      jumpToMoreBenefit(item, this.info.act_name)
    }
  },
  mounted() {},
  computed: {
    user() {
      return window.$bus.user;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.scroll-wrap
  overflow-x scroll
  overflow-y: hidden
  width: 100%
  padding-left 0.3rem
  &.white
    ul
      li
        background-color: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        .info
          .level
            color: #D9AC63;
            background: transparent;
  ul
    margin-top: 0.16rem
    li
      background: #F6F6F6;
      height 1.48rem
      margin-right: 0.16rem
      width: 6.9rem
      overflow hidden
      position: relative
      margin-bottom: 0.16rem
      border-radius: 0.08rem
      .info
        display: flex
        padding: 0.12rem
        width: 100%
        box-sizing: border-box
        .left
          max-width: 3rem
          margin: 0.2rem 0 0 0.14rem
        .title
          height: 0.4rem;
          font-size: 0.28rem;
          font-weight: 500;
          color: #111111;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
        .level
          height: 0.44rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #D9AC63;
          line-height: 0.44rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
          background: #FFECEC;
          border-radius: 8px;
          margin-top: 0.08rem;
          color: #F73D47;
          padding: 0 0.1rem
          display: inline-block
        .img-wrap
          width: 1.32rem
          height: 1.32rem
          overflow hidden
          img
            width: 100%
</style>
